"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pertica-bassa": {
    "71ec978c": [{
      "hkey": "854056c0",
      "slug": "avenone-villa-e-spessio",
      "name": "Avenone Villa e Spessio",
      "primary": true,
      "skipSearch": false
    }],
    "avenone-spessio": [{
      "hkey": "854056c0",
      "slug": "avenone-villa-e-spessio",
      "name": "Avenone Villa e Spessio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "90c63a62": [{
      "hkey": "cf91df00",
      "slug": "pertica-bassa",
      "name": "Pertica Bassa",
      "primary": true,
      "skipSearch": false
    }],
    "beata-vergine": [{
      "hkey": "cf91df00",
      "slug": "pertica-bassa",
      "name": "Pertica Bassa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;